import { gql } from "urql";
export const CreatePriorityEmailRecordMutation = gql `
    mutation CreatePriorityEmailRecord(
        $input: PriorityEmailRecordCreateInput!
    ) {
        priorityEmailRecords {
            createPriorityEmailRecord(input: $input) {
                priorityEmailRecordId
                priorityEntry {
                    invitationPending
                }
            }
        }
    }
`;
export const ResendPriorityEmailRecordEmailMutation = gql `
    mutation ResendPriorityEmailRecordEmail($priorityEmailRecordId: String!) {
        priorityEmailRecords {
            resendPriorityEmailRecord(
                priorityEmailRecordId: $priorityEmailRecordId
            ) {
                success
            }
        }
    }
`;
export const DeletePriorityEmailRecordMutation = gql `
    mutation DeletePriorityEmailRecord($priorityEmailRecordId: String!) {
        priorityEmailRecords {
            deletePriorityEmailRecord(
                priorityEmailRecordId: $priorityEmailRecordId
            ) {
                priorityEmailRecordId
            }
        }
    }
`;
